import { render, staticRenderFns } from "./MoreLikeText.vue?vue&type=template&id=01dd6526&scoped=true"
import script from "./MoreLikeText.vue?vue&type=script&lang=js"
export * from "./MoreLikeText.vue?vue&type=script&lang=js"
import style0 from "./MoreLikeText.vue?vue&type=style&index=0&id=01dd6526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd6526",
  null
  
)

export default component.exports